export default __webpack_public_path__ + "static/media/photo--sm--9.a321b386.jpg";